module.exports = __webpack_public_path__ + "img/question-bg-v2.020b4d11.png";